import { cn } from "./cn";

export function Logo({
  size = 28,
  label = true,
  className,
}: {
  size?: number;
  label?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img
        src="/logo.png"
        alt="Sidestack"
        width={size}
        height={size}
        className="block"
      />
      {label && (
        <span
          className="font-display italic font-bold tracking-tight text-td-1"
          style={{ fontSize: size * 0.7 }}
        >
          sidestack
        </span>
      )}
    </div>
  );
}
